import React from "react";
import InitializePage from '../../lib/server/page'
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import { useRouter } from 'next/router'
import HeaderTag from '../../components/meta.jsx';
import { getWebTexts } from '../../lib/api/common.jsx';
import { textsWeb, getText } from '../../lib/utils/langTexts'
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import Link from "next/link";


const NeustriaHistoria = ({menu, webTexts}) => {

    const router = useRouter()
    


  let hidenavbar = true;

  if(router.pathname ==  '/history' || router.pathname ==  '/contacto') {
    hidenavbar = false;
  }

  return (
    <>
        <Header page={'common'} menuSections={menu}/>
        <HeaderTag title="Eccediciones" description="eccediciones" />
            <div className="container innerpage main-container mt-50 static historia ckeditor" dangerouslySetInnerHTML={{ __html:webTexts.find(x=> x.webCode=="CONO001")?.webText}}></div>           

            {/*<div className="container innerpage main-container mt-50 static historia">
                <h2 className="A-la-venta-esta-sema">{webtexts.find(x=> x.webCode=="historia-007")?.webText}</h2>
                <div className="line4"></div>
                <h6 className="subheading">{webtexts.find(x=> x.webCode=="historia-001")?.webText}
                <br/>
                    {webtexts.find(x=> x.webCode=="historia-002")?.webText}
                </h6>
                <div dangerouslySetInnerHTML={{ __html:webtexts.find(x=> x.webCode=="historia-003")?.webText}}></div>
            </div>
                <div className="clearfix"></div>
            <div className="container innersec_images main-container static">
                <ul>
                    <li>
                        <img src="/assets/images/inner_img1.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                    </li>
                    <li>
                        <img src="/assets/images/inner_img2.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                    </li>
                </ul>
            </div>
                <div className="clearfix"></div>
            <div className="container innerpage main-container static my-tab-40">
                <div dangerouslySetInnerHTML={{ __html:webtexts.find(x=> x.webCode=="historia-004")?.webText}}></div>
            </div>
            <div className="container innersec_images1 main-container static">
                <img src="/assets/images/inner_img3.png" alt=""></img>
                <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
            </div>
            <div className="clearfix"></div>
            <div className="container innerpage main-container static">
                <div dangerouslySetInnerHTML={{ __html:webtexts.find(x=> x.webCode=="historia-005")?.webText}}></div>
            </div>
            <div className="clearfix"></div>
            <div className="container innersec_images3 main-container static">
                <ul>
                    <li data-toggle="modal" data-target="#modal"><a href="#lightbox" data-slide-to="0"><img src="/assets/images/inner_img5.png"></img></a></li>
                    <li data-toggle="modal" data-target="#modal"><a href="#lightbox" data-slide-to="1"><img src="/assets/images/inner_img6.png"></img></a></li>
                    <li data-toggle="modal" data-target="#modal"><a href="#lightbox" data-slide-to="2"><img src="/assets/images/inner_img7.png"></img></a></li>
                    <li data-toggle="modal" data-target="#modal"><a href="#lightbox" data-slide-to="3"><img src="/assets/images/inner_img8.png"></img></a></li>
                    <li data-toggle="modal" data-target="#modal"><a href="#lightbox" data-slide-to="4"><img src="/assets/images/inner_img9.png"></img></a></li>
                    <li data-toggle="modal" data-target="#modal"><a href="#lightbox" data-slide-to="5"><img src="/assets/images/inner_img10.png"></img></a></li>
                </ul>
            </div>
            <div class="modal fade image-lightbox" id="modal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div id="lightbox" class="carousel slide" data-ride="carousel" data-interval="5000" data-keyboard="true">
                    <a class="carousel-control-prev" href="#lightbox" role="button" data-slide="prev"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>
                    <a class="carousel-control-next" href="#lightbox" role="button" data-slide="next"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>
                                <div class="carousel-inner">
                                    <div class="carousel-item active"><img src="/assets/images/inner_img5.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                        </div>
                                    <div class="carousel-item"><img src="/assets/images/inner_img6.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                        </div>
                                    <div class="carousel-item"><img src="/assets/images/inner_img7.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                        </div>
                                    <div class="carousel-item"><img src="/assets/images/inner_img8.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                        </div>
                                    <div class="carousel-item"><img src="/assets/images/inner_img9.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                        </div>
                                    <div class="carousel-item"><img src="/assets/images/inner_img10.png"></img>
                        <p><i>Pie de página de la fotografía dentro de un texto.</i></p>
                        </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix"></div>
            <div className="container innerpage main-container static mt-40 mb-10 historia-last-wrapper">
                <div dangerouslySetInnerHTML={{ __html:webtexts.find(x=> x.webCode=="historia-006")?.webText}}></div>
            </div>
            <div className="clearfix"></div>
            <div className="container links main-container static historia">
                <ul>
                    <li><Link href="/nuestras-tiendas">Nuestras tiendas</Link></li>
                    <li><Link href="/nuestras-webs">Nuestras webs</Link></li>
                    <li><Link href="/contacto">Contacto</Link></li>
                </ul>
            </div>*/}
            <div className="container line-container">
                <div className="line6"></div>
            </div>
        <SubscribeNewsLetter webTexts={webTexts}/>
        <HomeFooter />
    </>
  );
};

async function loadData(context){      
    const webtexts = await getWebTexts(textsWeb.meetUs);

    return {webTexts:webtexts?.data}
}
export async function getStaticProps(context) {    
    return InitializePage(context,loadData, true)
}

export default NeustriaHistoria;
